import { render } from "./LiveStream.vue?vue&type=template&id=da4012e4&scoped=true&ts=true"
import script from "./LiveStream.vue?vue&type=script&lang=ts"
export * from "./LiveStream.vue?vue&type=script&lang=ts"

import "./LiveStream.vue?vue&type=style&index=0&id=da4012e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da4012e4"]])

export default __exports__